import React from 'react';

import './fixtureData.scss';

interface Props {
    firstIcon?: JSX.Element | null;
    secondIcon?: JSX.Element | null;
    thirdIcon?: JSX.Element | null;
    text?: string | null;
    subText?: string | null;
}

const FixtureData: React.FC<Props> = ({
    firstIcon,
    secondIcon,
    thirdIcon,
    text,
    subText,
}) => {
    return (
        <div styleName="container">
            {firstIcon && <div styleName="icon">{firstIcon}</div>}
            {(text || subText) && (
                <div styleName="text">
                    {text && <span>{text}</span>}
                    {subText && <span>{subText}</span>}
                </div>
            )}

            {secondIcon && <div styleName="icon">{secondIcon}</div>}
            {thirdIcon && <div styleName="icon">{thirdIcon}</div>}
        </div>
    );
};

export default FixtureData;
